//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  props: {
    title: {
      type: String,
      default: null
    },
    imgList: {
      type: Array,
      default: null
    },
    text: {
      type: String,
      default: null
    }
  }
}
